import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const API = import.meta.env.VITE_API_URL || '/api'
function getHeaders() { const t = localStorage.getItem('token'); return { 'Content-Type': 'application/json', Authorization: t ? `Bearer ${t}` : '' } }

export default function AdminMessages() {
  const [messages, setMessages] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  const fetchMessages = async () => {
    const r = await fetch(`${API}/contact/messages`, { headers: getHeaders() })
    setMessages(await r.json())
    setLoading(false)
  }

  useEffect(() => { fetchMessages() }, [])

  const markRead = async (id: number) => {
    await fetch(`${API}/contact/messages/${id}/read`, { method: 'PUT', headers: getHeaders() })
    fetchMessages()
  }

  const deleteMsg = async (id: number) => {
    await fetch(`${API}/contact/messages/${id}`, { method: 'DELETE', headers: getHeaders() })
    fetchMessages()
  }

  if (loading) return <div className="text-center py-12 text-gray-400">Loading...</div>

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Contact Messages</h1>
      <div className="space-y-4">
        {messages.length === 0 && <p className="text-gray-400 text-center py-8">No messages yet</p>}
        {messages.map((msg) => (
          <motion.div
            key={msg.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className={`bg-gray-900 border rounded-xl p-5 ${msg.read ? 'border-white/5' : 'border-electric-blue/30'}`}
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-white font-medium">{msg.name}</h3>
                <p className="text-sm text-gray-400">{msg.email} {msg.phone && `• ${msg.phone}`}</p>
              </div>
              <div className="flex gap-2">
                {!msg.read && (
                  <button onClick={() => markRead(msg.id)} className="text-xs px-3 py-1.5 bg-electric-blue/20 text-electric-blue rounded-lg hover:bg-electric-blue/30 transition-colors">
                    Mark Read
                  </button>
                )}
                <button onClick={() => deleteMsg(msg.id)} className="text-xs px-3 py-1.5 bg-red-500/20 text-red-400 rounded-lg hover:bg-red-500/30 transition-colors">
                  Delete
                </button>
              </div>
            </div>
            {msg.subject && <p className="text-sm text-gray-300 mb-2"><strong>Subject:</strong> {msg.subject}</p>}
            <p className="text-gray-400 text-sm whitespace-pre-wrap">{msg.message}</p>
            <p className="text-xs text-gray-500 mt-3">{new Date(msg.created_at).toLocaleString()}</p>
          </motion.div>
        ))}
      </div>
    </div>
  )
}
